module.exports = __webpack_public_path__ + "395b6ccf13c07d77980d79b2607106a0.gif";